<template>

    <m-edit1/>

    <m-section-204 v-bind='{...{"image":"https:\/\/api.mixitweb.com\/storage\/assets\/hero2.png"},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center " >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="text-white " >
                <template #default>قدرت فنی ما، پشتوانه موفقیت شما!   </template>
                </m-h1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center mb-4" >
                <template #default>   <m-p v-bind='{...{},...{}}' :style='"font-weight:bolder;"' class="text-white col-6 mx-auto" >
                <template #default>اگر به دنبال تیمی فنی، حرفه‌ای و متعهد هستید که بتواند رویاهای دیجیتال شما را به واقعیت تبدیل کند، ما اینجا هستیم! تیم متخصص ما با دانش فنی بالا، راهکارهای خلاقانه و پشتیبانی بی‌وقفه آماده است تا به هر سوال، نیاز یا چالشی که دارید، پاسخ دهد.

با ما تماس بگیرید تا از تخصص و تجربه‌ای که شما را به سطح بالاتری در دنیای وب می‌رساند، بهره‌مند شوید. موفقیت شما، مأموریت ماست.   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12 text-center mb-5" >
                <template #default>   <m-video v-bind='{...{"controls":true,"videoSrc":"https:\/\/api.mixitweb.com\/storage\/videos\/ba20d770d9dafc8c741c27ca535e5ada51151345-720p.mp4","autoplay":false,"muted":false,"loop":false,"poster":null},...{}}' :style='"border-radius: 25px;\nmax-height:360px;"' class=" shadow  img-fluid " ></m-video></template>
                </m-div></template>
                </m-div></template>
                </m-section-204><m-div v-bind='{...{},...{}}' :style='""' class="container mb-4" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>راه های ارتباطی   </template>
                </m-h1><m-a v-bind='{...{"href":"tel:06191011191","target":"_self"},...{}}' :style='""' class="col-12" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>06191011191   </template>
                </m-h1></template>
                </m-a><m-a v-bind='{...{"href":"tel:09365249788","target":"_self"},...{}}' :style='""' class="col-12" >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>09365249788   </template>
                </m-h1></template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-6" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":1,"redirectToDashboard":true},...{}}' :style='"border-radius:25px"' class="bg-white border shadow-sm p-4" ></m-form-single-1></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mSection204 from '@moeinmdn/miw-alpha-components/src/package/Sections/Section204'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mVideo from '@moeinmdn/miw-alpha-components/src/package/Tags/Video'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mSection204,mDiv,mH1,mP,mVideo,mA,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
